import React from 'react';
import { SearchXIcon } from 'lucide-react';
export const NoResultsState = () => {
  return <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-80 z-[25]" data-id="element-266">
      <div className="text-center p-6 max-w-md" data-id="element-267">
        <SearchXIcon className="h-12 w-12 text-gray-400 mx-auto mb-4" data-id="element-268" />
        <p className="text-lg font-medium text-gray-800" data-id="element-269">
          কোন ফলাফল পাওয়া যায়নি
        </p>
        <p className="text-sm text-gray-600 mt-2" data-id="element-270">(No results found)</p>
        <p className="text-sm text-blue-600 mt-4" data-id="element-271">
          অন্য ফিল্টার নির্বাচন করে আবার চেষ্টা করুন
        </p>
      </div>
    </div>;
};